module.exports = __webpack_public_path__ + "static/media/LICHSGFIN.f845efc8.txt";